import find from 'lodash/find'
import { FieldOption } from './accountTypes'

const options: FieldOption[] = [
  { value: 'hold', name: 'Hold' },
  { value: 'offered', name: 'Offered' },
  { value: 'accepted', name: 'Accepted' },
  { value: 'declined', name: 'Declined' }
]

export default options

export function statusName (value: string): string | null {
  const option = find(options, { value })
  return option ? option.name : null
}
